export default "/static/media/icon-arrow-back.ba23e09a.svg";